import { Box, Heading } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SendTo from './sendTo';
import WhenField from './whenField';
import Body from './body';
import { setActions, updateActions } from './formActionsSlice';
import SubjectField from './SubjectField';
import { getForm } from '../FormSetup/formSlice';

const getDefautlSendTo = (actions = []) => {
  if (actions.length === 0) return undefined;
  if (actions[0].to && !Array.isArray(actions[0].to)) return [{ mail: actions[0].to, validated: true }];
  return actions[0].sendto;
};

const FormActions = ({ actions = [] }) => {
  const user = useSelector((state) => state.account.user);
  const { dirty } = useSelector(getForm);
  const dispatch = useDispatch();
  const shouldUpdate = useRef(false);
  const {
    register, handleSubmit, control, watch, getFieldState, reset,
    // eslint-disable-next-line no-unused-vars
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      type: '',
      sendto: [],
      when: '',
    },
  });
  const onSubmit = async () => { };

  useEffect(() => {
    if (!dirty) {
      const defaultSendto = getDefautlSendTo(actions);

      const a = [{
        type: 'email',
        sendto: defaultSendto || [{ mail: user.email, validated: true }],
        when: (actions.length > 0 ? actions[0].when : undefined) || 'onsubmit',
        subject: actions.length > 0 ? actions[0].subject : 'Form response',
      }];
      dispatch(setActions(a));
      shouldUpdate.current = false;
      reset(a[0]);
    }
  }, [dirty]);

  useEffect(() => {
    const subscription = watch((value) => {
      if (shouldUpdate.current) {
        dispatch(updateActions([value]));
      } else {
        shouldUpdate.current = true;
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Box>
      <Heading size="lg">Email </Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <SendTo control={control} />
        <WhenField control={control} />
        <SubjectField register={register} getFieldState={getFieldState} watch={watch} />
        <Body control={control} />
      </form>
    </Box>
  );
};

export default FormActions;
